const actionTypes = {
  SERVICE_CONFIG_DETAIL: 'SERVICE_CONFIG_DETAIL',
  COURSE_DETAIL_INFO: 'COURSE_DETAIL_INFO',
  SERVICE_CONFIG: 'SERVICE_CONFIG',
  COURSE_BTN_STATUS: 'COURSE_BTN_STATUS',
  COURSE_LESSON_INFO: 'COURSE_LESSON_INFO',
  COURSE_ALL_TAB: 'COURSE_ALL_TAB'
};
export default actionTypes;